import {
  addDoc,
  collection,
  getDoc,
  serverTimestamp,
} from "firebase/firestore";
import { omit } from "lodash";
import { db } from "shared/api/firebase";
import { v4 as uuidv4 } from "uuid";
import { BroadcastToCreate, Broadcast } from "../types";
import { saveBroadcastImage } from "./saveBroadcastImage";

export const createBroadcast = async (
  broadcast: BroadcastToCreate,
): Promise<Broadcast> => {
  const collectionRef = collection(db, `broadcasts`);

  try {
    let imageUrl = "";
    let uniqueImageKey = "";

    if (broadcast.message.image instanceof File) {
      uniqueImageKey = uuidv4();

      // Upload the image and get the URL using the unique key
      imageUrl = await saveBroadcastImage({
        keyImage: uniqueImageKey,
        image: broadcast.message.image,
      });
    }
    const broadcastDoc = await addDoc(collectionRef, {
      ...broadcast,
      message: {
        ...omit(broadcast.message, "image"), // Remove the File object
        ...(imageUrl && { image: imageUrl }),
      },
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
    });

    const updatedBroadcastSnapshot = await getDoc(broadcastDoc);
    const data = updatedBroadcastSnapshot.data() as Broadcast;

    return {
      ...data,
      id: broadcastDoc.id,
    };
  } catch (error) {
    console.error("Failed to create the broadcast:", error);
    throw error;
  }
};
